import { useSelector } from "react-redux";
import { Redirect, Route, Switch } from "react-router-dom";
import { getLenderConfig } from "../../actions/lender.action";
import Agreements from "../../containers/agreements";
import ApplicationDetailsScreen from "../../containers/application-details";
import SingleCommercialLoanOdApplication from "../../containers/application-details/commercial-od/singleApplication";
import { WCTLApplicationDetailsScreen } from "../../containers/application-details/wctl";
import ApplicationsScreen from "../../containers/applications";
import Borrowers from "../../containers/borrowers";
import DashboardScreen from "../../containers/dashboard";
import EnterpriseLoans from "../../containers/enterprise-loans";
import EnterpriseUserScreen from "../../containers/enterprise-users";
import SingleEnterpriseScreen from "../../containers/enterprise-users/individual/singleEnterpriseScreen";
import Invoice from "../../containers/invoice";
import CommercialODLoan from "../../containers/loan-details/commercial-loan/commercial-loan";
import WCTLoanDetailsScreen from "../../containers/loan-details/wctl-loan";
import LoanScreen from "../../containers/loans";
import PersonalLoanDetailsContainer from "../../containers/personal-loan-details";
import DrawdownDetails from "../../containers/personal-loan-details/drawdown-details";
import Portfolio from "../../containers/portfolio";
import ProfileScreen from "../../containers/profile";
import PortalAccessPage from "../../containers/portal-access";
import RefundApproval from "../../containers/refund-approval";
import AuditLogsPage from "../../containers/credit-decision/audit-logs";
import AuditLogDetailPage from "../../containers/credit-decision/audit-logs/detail";
import PreApprovalsPage from "../../containers/credit-decision/pre-approvals";
import PricingPage from "../../containers/credit-decision/pricing";
import PricingDetailPage from "../../containers/credit-decision/pricing/detail";
import ManualReviewListPage from "../../containers/credit-decision/manual-review";
import ManualReviewDetailPage from "../../containers/credit-decision/manual-review/detail";
import PolicySimulationsPage from "../../containers/credit-decision/policy-simulations";
import PolicySimulationRunDetailPage from "../../containers/credit-decision/policy-simulations/detail";
import Employers from "../../containers/employers";
import EmployerDetails from "../../containers/employers/EmployerDetails";
import ExecutionEmbedPage from "../../containers/underwriting-ui/ExecutionEmbedPage";
import PoliciesIndexPage from "../../containers/underwriting-ui/PoliciesIndexPage";
import UnderwritingPolicyAttachmentsScreen from "../../containers/underwriting-policy-attachments";
import PolicyAttachmentTimelinePage from "../../containers/underwriting-policy-attachments/PolicyAttachmentTimelinePage";
import PolicyCompareEmbedPage from "../../containers/underwriting-ui/PolicyCompareEmbedPage";
import PolicyDetailsEmbedPage from "../../containers/underwriting-ui/PolicyDetailsEmbedPage";
import PolicySimulateEmbedPage from "../../containers/underwriting-ui/PolicySimulateEmbedPage";
import ReportsScreen from "../../containers/reports";
import SingleUserScreen from "../../containers/user-details/individual";
import UserScreen from "../../containers/users";
import { useEnableDashboardStats } from "../../hooks/useEnableDashbaordStats";
import Layout from "../../layout";
import { RoutePaths } from "../../models";
import { ReduxState } from "../../reducers";


export default function PrivateRoutes() {
  const lenderId = useSelector(
    (state: ReduxState) => state.admin.data?.lenderId,
  );

  const { isEnabled: shouldShowDashboard } = useEnableDashboardStats({
    action: getLenderConfig(lenderId),
  });

  return (
    <Layout>
      <Switch>
        {shouldShowDashboard ? (
          <Route
            path={RoutePaths.DASHBOARD}
            exact
            component={DashboardScreen}
          />
        ) : (
          <Redirect
            exact
            from={RoutePaths.DASHBOARD}
            to={RoutePaths.PERSONAL_LOANS}
          />
        )}

        <Route
          path={RoutePaths.INDIVIDUAL_USERS}
          exact
          component={UserScreen}
        />
        <Route
          path={RoutePaths.ENTERPRISE_USERS}
          exact
          component={EnterpriseUserScreen}
        />
        <Route
          path={`${RoutePaths.ENTERPRISE_USERS}/:id`}
          component={SingleEnterpriseScreen}
        />
        <Route
          path={`${RoutePaths.INDIVIDUAL_USERS}/:userId`}
          component={SingleUserScreen}
        />
        <Route
          path={RoutePaths.APPLICATIONS}
          exact
          component={ApplicationsScreen}
        />
        <Route
          path={`${RoutePaths.APPLICATIONS}/:appId`}
          exact
          component={ApplicationDetailsScreen}
        />
        <Route
          path={`${RoutePaths.COMMERCIAL_LOAN_APPLICATION}/:appId`}
          exact
          component={SingleCommercialLoanOdApplication}
        />
        <Route
          path={`${RoutePaths.WCTL_LOAN_APPLICATION}/:appId`}
          exact
          component={WCTLApplicationDetailsScreen}
        />
        <Route
          path={`${RoutePaths.ENTERPRISE_LOANS}${RoutePaths.WORKING_CAPITAL_TERM_LOAN}/:loanId`}
          exact
          component={WCTLoanDetailsScreen}
        />
        <Route path={RoutePaths.PERSONAL_LOANS} exact component={LoanScreen} />
        <Route
          path={`${RoutePaths.ENTERPRISE_LOANS}/commercial/:loanId`}
          component={CommercialODLoan}
        />
        <Route
          path={`${RoutePaths.PERSONAL_LOANS}/:loanId`}
          component={PersonalLoanDetailsContainer}
        />
        <Route path={RoutePaths.BORROWERS} exact component={Borrowers} />
        <Route path={RoutePaths.INVOICE} component={Invoice} />
        <Route
          path={RoutePaths.REPORT_CENTER}
          exact
          component={ReportsScreen}
        />
        <Route path={RoutePaths.PROFILE} exact component={ProfileScreen} />
        <Route
          path={RoutePaths.PORTAL_ACCESS}
          exact
          component={PortalAccessPage}
        />
        <Route path={RoutePaths.AGREEMENTS} exact component={Agreements} />
        <Route path={RoutePaths.PORTFOLIO} exact component={Portfolio} />
        <Route
          path={RoutePaths.REFUND_APPROVAL}
          exact
          component={RefundApproval}
        />
        <Route
          path={RoutePaths.ENTERPRISE_LOANS}
          exact
          component={EnterpriseLoans}
        />
        <Route
          path={`${RoutePaths.DRAWDOWN_DETAILS}/:drawdownId`}
          exact
          component={DrawdownDetails}
        />
        <Route
          path={RoutePaths.ANGRY_ARYABHATTA}
          exact
          component={() => <ReportsScreen isPreProd />}
        />
        <Route path={RoutePaths.EMPLOYERS} exact component={Employers} />
        <Route
          path={`${RoutePaths.EMPLOYERS}/:id`}
          exact
          component={EmployerDetails}
        />
        <Route
          path={RoutePaths.CREDIT_DECISION_AUDIT_LOG_DETAIL}
          exact
          component={AuditLogDetailPage}
        />
        <Route
          path={RoutePaths.CREDIT_DECISION_AUDIT_LOGS}
          exact
          component={AuditLogsPage}
        />
        <Route
          path={RoutePaths.CREDIT_DECISION_PRE_APPROVALS}
          exact
          component={PreApprovalsPage}
        />
        <Route
          path={RoutePaths.CREDIT_DECISION_PRICING_DETAIL}
          exact
          component={PricingDetailPage}
        />
        <Route
          path={RoutePaths.CREDIT_DECISION_PRICING}
          exact
          component={PricingPage}
        />
        <Route
          path={RoutePaths.CREDIT_DECISION_MANUAL_REVIEW_DETAIL}
          exact
          component={ManualReviewDetailPage}
        />
        <Route
          path={RoutePaths.CREDIT_DECISION_MANUAL_REVIEW}
          exact
          component={ManualReviewListPage}
        />
        <Route
          path={RoutePaths.CREDIT_DECISION_POLICY_SIMULATION_DETAIL}
          exact
          component={PolicySimulationRunDetailPage}
        />
        <Route
          path={RoutePaths.CREDIT_DECISION_POLICY_SIMULATIONS}
          exact
          component={PolicySimulationsPage}
        />
        <Route
          path={RoutePaths.UNDERWRITING_POLICY_ATTACHMENTS}
          exact
          component={UnderwritingPolicyAttachmentsScreen}
        />
        <Route
          path={RoutePaths.UNDERWRITING_POLICY_ATTACHMENTS_TIMELINE}
          exact
          component={PolicyAttachmentTimelinePage}
        />
        <Route
          path={RoutePaths.UNDERWRITING_UI_POLICIES}
          exact
          component={PoliciesIndexPage}
        />
        <Route
          path={RoutePaths.UNDERWRITING_UI_POLICY_COMPARE}
          exact
          component={PolicyCompareEmbedPage}
        />
        <Route
          path={RoutePaths.UNDERWRITING_UI_EXECUTION_DETAIL}
          exact
          component={ExecutionEmbedPage}
        />
        <Route
          path={RoutePaths.UNDERWRITING_UI_POLICY_SIMULATE}
          exact
          component={PolicySimulateEmbedPage}
        />
        <Route
          path={RoutePaths.UNDERWRITING_UI_POLICY_DETAIL}
          exact
          component={PolicyDetailsEmbedPage}
        />
        <Redirect from={RoutePaths.USERS} to={RoutePaths.INDIVIDUAL_USERS} />
      </Switch>
    </Layout>
  );
}
